<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in">{{modalData.requisitionSPOC.currentStateName}} Requisition</h4>
</div>
<div class="modal-body">
    <form *ngIf="modalData.requisitionSPOC.currentStateName !== MESSAGECONSTANTS.VIEW_REQUISITION.FILL_STATE && modalData.requisitionSPOC.currentStateName !== MESSAGECONSTANTS.VIEW_REQUISITION.JOIN_STATE"
        #actionform="ngForm" (ngSubmit)="actionform.valid && onModifyRequisitionStates('Forward')" novalidate>
        <div class="form-group wrap-text-in">
            <label class="modal-body-font-size"
                *ngIf="modalData.requisitionSPOC.currentStateName !== MESSAGECONSTANTS.VIEW_REQUISITION.FILLED_STATE && modalData.requisitionSPOC.currentStateName !== MESSAGECONSTANTS.VIEW_REQUISITION.JOINED_STATE">
                <span class="updateReqtextcolor">'{{modalData.requisitionSPOC.currentStateName}}' </span>the
                Requisition
                <span class="updateReqtextcolor"> '{{modalData.requisitionSPOC.Role}}' </span>
                <span *ngIf="modalData.requisitionSPOC.Company !== null && modalData.requisitionSPOC.Company !== undefined">for
                    <span class="updateReqtextcolor">'{{modalData.requisitionSPOC.Company}}'</span></span>
            </label>
            <div *ngIf="modalData.requisitionSPOC.currentStateName === 'Delete'">
                <p>This action cannot be <b>undone</b>.</p>
                <p>All candidate matches associated with this job requisition will be deleted.</p>
                <p>Number of candidates matching this job is <span class="emerald">{{modalData.requisitionSPOC.activeCandidateCount + modalData.requisitionSPOC.passiveCandidateCount + modalData.requisitionSPOC.inertCandidateCount}}.</span>
                </p>
                <p>The job requisition will then be deleted.</p>
            </div>
            <p *ngIf="modalData.requisitionSPOC.currentStateName === MESSAGECONSTANTS.VIEW_REQUISITION.JOIN_STATE">
                The Job Match status for all the other jobs that the candidate is on will be set to <br>'<span class="emerald">Not
                    Interested</span>'.
            </p>
            <p>Are you sure you want to continue?</p>
        </div>

        <div class="form-group">
            <div class="row">
                <div class="col-xs-6" [ngClass]="{'has-error':(actionform.submitted && fromDate.invalid)}">
                    <label for="currentDate">Date</label>
                    <div class="input-group">
                        <span class="input-group-addon">
                            <i class="fa fa-calendar"></i>
                        </span>
                        <input type="text" class="form-control access" placeholder="mm-dd-yyyy" id="currentDate" name="currentDate"
                            #fromDate="ngModel" [(ngModel)]="modalData.requisitionSPOC.date" required [disabled]="true">
                    </div>
                    <div class="error error-gap" *ngIf="actionform.submitted">
                        <small *ngIf="fromDate.errors?.required"><em>*</em> Date is required</small>
                    </div>
                </div>

                <div class="col-xs-6" [ngClass]="{'has-error':(actionform.submitted && time.invalid)}">
                    <label for="time">Time</label>
                    <div class="input-group">
                        <span class="input-group-addon">
                            <i class="far fa-clock"></i>
                        </span>
                        <input type="text" class="form-control access" placeholder="hh:mm:ss" [(ngModel)]="modalData.requisitionSPOC.time"
                            id="time" name="time" #time="ngModel" required [disabled]="true">
                    </div>
                    <div class="error error-gap" *ngIf="actionform.submitted">
                        <small *ngIf="time.errors?.required"><em>*</em> Time is required </small>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group">
            <div class="row"
                *ngIf="modalData.requisitionSPOC.currentStateName === MESSAGECONSTANTS.VIEW_REQUISITION.FILL_STATE || modalData.requisitionSPOC.currentStateName === MESSAGECONSTANTS.VIEW_REQUISITION.JOIN_STATE || modalData.requisitionSPOC.currentStateName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE || modalData.requisitionSPOC.currentStateName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE">
                <div class="col-xs-12" [ngClass]="{'has-error':(actionform.submitted && modalData.requisitionSPOC.candidate === undefined)}">
                    <label for="interviewCompletedCandidate">Candidate<em> * </em>
                        <span class="text-danger" style="font-size: 12px;"
                            *ngIf="modalData.requisitionSPOC.currentStateName === MESSAGECONSTANTS.VIEW_REQUISITION.JOIN_STATE">
                            (All the other Job Matches that the candidate is currently on will be set to 'Not
                            Interested'.)
                        </span>
                    </label>
                    <select name="interviewCompletedCandidate" id="interviewCompletedCandidate"
                        class="form-control btn btn-secondary inputBoxBorder dropdown-toggle"
                        [(ngModel)]="modalData.requisitionSPOC.candidate" required>
                        <option *ngFor="let t of modalData.candidates" [ngValue]="t">{{t.name}}</option>
                    </select>
                    <div class="error error-gap" *ngIf="actionform.submitted">
                        <small *ngIf="modalData.requisitionSPOC.candidate === undefined"><em>*</em>
                            Please select a candidate</small>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group" [ngClass]="{'has-error':(actionform.submitted && note.invalid)}">
            <label>Notes <em> * </em></label>
            <div>
                <!-- Voice Input -->
                <div class="mb-2">
                    <app-voice-input
                        (transcriptReady)="onVoiceTranscript($event)"
                        [sourceScreen]="'REQUISITION'"
                        [candidate]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.candidate : null"
                        [company]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.company : null"
                        [requisition]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.requisition : null"
                        [jobMatch]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.jobMatch : null">
                    </app-voice-input>
                </div>
                <textarea name="note" class="form-control" style="height: 100px; width: 100%;resize: none;" maxlength="503"
                    #note="ngModel" [(ngModel)]="modalData.requisitionSPOC.note" required
                    (ngModelChange)="modalData.isSharedRequisition && copyNote && onInternalNoteChanged()">
                </textarea>
            </div>
            <div class="error error-gap" *ngIf="actionform.submitted">
                <small *ngIf="note.errors?.required"><em>*</em> Note is required</small>
            </div>
            <!-- Formalize Text -->
            <app-formalize-comment
                [inputText]="modalData.requisitionSPOC.note"
                (outputText)="receiveFormalizedComment($event)"
                [sourceScreen]="'REQUISITION'"
                [candidate]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.candidate : null"
                [company]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.company : null"
                [requisition]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.requisition : null"
                [jobMatch]="modalData.formalizeActivityPayload ? modalData.formalizeActivityPayload.jobMatch : null">
            </app-formalize-comment>
        </div>
        <app-external-notes
            *ngIf="modalData.isSharedRequisition && (modalData.requisitionSPOC.currentStateName === MESSAGECONSTANTS.VIEW_REQUISITION.FILL_STATE || modalData.requisitionSPOC.currentStateName === MESSAGECONSTANTS.VIEW_REQUISITION.JOIN_STATE || modalData.requisitionSPOC.currentStateName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_FILLED_CANDIDATE || modalData.requisitionSPOC.currentStateName === MESSAGECONSTANTS.VIEW_REQUISITION.REMOVE_JOINED_CANDIDATE)"
            [form]="actionform" [note]="modalData.requisitionSPOC.note" [copyNote]="copyNote"
            [externalNote]="modalData.requisitionSPOC.externalNote" (onExternalNoteChange)="onExternalNoteChange($event)"
            (onCopyNoteChange)="onCopyNoteChange($event)" [sourceScreen]="'REQUISITION'"
            [formalizeActivityPayload]="modalData.formalizeActivityPayload">
        </app-external-notes>
        <div class="modal-footer">
            <button type="button" class="btn btn-danger" (click)="closeModal()" [disabled]="isDeleteInProgress">Cancel</button>
            <button type="submit" *ngIf="modalData.requisitionSPOC.currentStateName !== 'Delete'" class="btn btn-primary">Ok</button>
            <button type="button" *ngIf="modalData.requisitionSPOC.currentStateName === 'Delete' && !isDeleteInProgress"
                (click)="onModifyRequisitionStates('Forward')" class="btn btn-primary">Delete</button>
            <button type="button" *ngIf="modalData.requisitionSPOC.currentStateName === 'Delete' && isDeleteInProgress"
                [disabled]="isDeleteInProgress" class="btn btn-primary">Deleting..</button>
        </div>
    </form>
    <app-fill-or-join-candidate
        *ngIf="modalData.requisitionSPOC.currentStateName === MESSAGECONSTANTS.VIEW_REQUISITION.FILL_STATE || modalData.requisitionSPOC.currentStateName === MESSAGECONSTANTS.VIEW_REQUISITION.JOIN_STATE"
        [job]="modalData.requisitionSPOC"
        [candidates]="modalData.candidates"
        [candidatesInLastStep]="modalData.candidatesInLastStep"
        [isSharedRequisition]="modalData.isSharedRequisition"
        (saveCallback)="onModifyRequisitionStates('Forward')"
        (cancelCallback)="closeModal()"
        [sourceScreen]="'REQUISITION'"
        [formalizeActivityPayload]="modalData.formalizeActivityPayload">
    </app-fill-or-join-candidate>
</div>
